"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bnToHex = void 0;
function bnToHex(bnParam) {
    const bn = BigInt(bnParam);
    let hex = bn.toString(16);
    if (hex.length % 2) {
        hex = `0${hex}`;
    }
    return hex;
}
exports.bnToHex = bnToHex;
